import { Api } from '../api/axios-config';

const getErrorMessage = (error: any, fallback: string) =>
    error?.response?.data?.message || error?.message || fallback;

type TSupportConfig = { whatsapp: string; email: string };

const getSupportConfig = async (): Promise<TSupportConfig | Error> => {
    try {
        const { data } = await Api.get('/settings/support');
        return data;
    } catch (error) {
        return new Error(getErrorMessage(error, 'Não foi possível carregar os canais de suporte.'));
    }
};

const updateSupportConfig = async (whatsapp: string, email: string): Promise<TSupportConfig & { message: string } | Error> => {
    try {
        const { data } = await Api.put('/settings/support', { whatsapp, email });
        return data;
    } catch (error) {
        return new Error(getErrorMessage(error, 'Não foi possível atualizar os canais de suporte.'));
    }
};

export const SettingsService = { getSupportConfig, updateSupportConfig };
